// src/components/homePage/MainDashboard.jsx
import { useEffect, useState } from "react";
import { Stack, Modal, Box } from "@mui/material";

import useDashboardData from "../../features/dashboard/hooks/useDashboardData";
import Sidebar from "../layout/Sidebar";
import Header from "../layout/Header";
import HomePageQueries from "../explainationPage/HomePageQueries";
import UsersMetricsCharts from "./UsersMetricsCharts/UsersMetricsCharts";

const MainDashboard = () => {
  const { fetchAllData ,fetchMetadata } = useDashboardData();
  const [isModalOpen, setIsModalOpen] = useState(false);



  useEffect(() => {
  fetchMetadata(); // once
}, [fetchMetadata]);


  // ── Fetch on mount ─────────────────────────────────────────
  useEffect(() => {
    fetchAllData();
  }, [fetchAllData]);
  // Note: fetchAllData is memoized with useCallback + filters dependency
  // so this re-runs automatically whenever any filter changes

  // ── Modal handlers ─────────────────────────────────────────
  const handleModalOpen = () => setIsModalOpen(true);
  const handleModalClose = () => setIsModalOpen(false);

  return (
    <Stack direction="row">
      <Sidebar />

      <Stack flexBasis="100%">
        <Header explainationButton={handleModalOpen} />
        <UsersMetricsCharts />
      </Stack>

      <Modal
        open={isModalOpen}
        onClose={handleModalClose}
        aria-labelledby="homepage-queries-modal-title"
        aria-describedby="homepage-queries-modal-description"
      >
        <Box>
          <HomePageQueries setOpen={setIsModalOpen} />
        </Box>
      </Modal>
    </Stack>
  );
};

export default MainDashboard;
